namespace RedBullMOBILE360.CustomerCare {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.CustomerCare.LineTerminationReportDialog')
    export class LineTerminationReportDialog extends Serenity.EntityDialog<LineTerminationReportRow, any> {
        protected getFormKey() { return LineTerminationReportForm.formKey; }
        protected getIdProperty() { return LineTerminationReportRow.idProperty; }
        protected getLocalTextPrefix() { return LineTerminationReportRow.localTextPrefix; }
        protected getNameProperty() { return LineTerminationReportRow.nameProperty; }
        protected getService() { return LineTerminationReportService.baseUrl; }
        protected getDeletePermission() { return LineTerminationReportRow.deletePermission; }
        protected getInsertPermission() { return LineTerminationReportRow.insertPermission; }
        protected getUpdatePermission() { return LineTerminationReportRow.updatePermission; }

        protected form = new LineTerminationReportForm(this.idPrefix);
    }
}